export default function cleanWhitespace(node, item, list) {
    list.remove(item);
};
